import { setHtml } from "../browser/setHtml";

export function ds24cart_windowHeight()
{
    return window.innerHeight;
}

export function ds24cart_windowWidth()
{
    return window.innerWidth;
}

export function ds24cart_windowScrollLeft() {
    return window.scrollY ?? window.pageXOffset;
}

export function ds24cart_windowScrollTop() {
    return window.scrollY ?? window.pageYOffset;
}

export function ds24cart_updateItemCount( count: number )
{
    setHtml(document.querySelector('button.app_cart_button .cart_item_count'), '' + count );
}

export function ds24cart_isFullscreen() {
    var window_width  = ds24cart_windowWidth();
    var window_height = ds24cart_windowHeight();

    return window_width < 600 && window_height < 800;
}